module.exports = __webpack_public_path__ + "img/location_blue_line.95acf512.svg";